import { forwardRef } from 'react';

import { Box, CircularProgress, Fade, Grid, Stack, SxProps, Theme } from '@mui/material';
import { Spinner } from '@natter-co/design-system';
import { useInheritedVisualRefresh } from 'common/theme';

export const cover: SxProps<Theme> = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 1,
  top: 0,
  left: 0,
};

type LoaderProps = {
  label: string;
  isTransitionDelay: boolean;
  sx?: SxProps<Theme>;
  size?: 24 | 40;
};

export const Loader = forwardRef<HTMLElement, LoaderProps>(({ label, sx, isTransitionDelay, size }, ref) => {
  const visualRefresh = useInheritedVisualRefresh();

  return (
    <Box ref={ref} sx={{ position: 'relative', width: '100%', height: '100%', minHeight: 'inherit', ...sx }}>
      <Grid container justifyContent="center" alignItems="center" sx={cover}>
        <Grid item className={visualRefresh ? 'min-w-0 max-w-full' : undefined}>
          {visualRefresh ? (
            <Spinner
              label={label}
              className="max-w-full"
              showLabel={size !== 24}
              size={size === 24 ? 'md' : 'xl'}
              delayed={isTransitionDelay}
              data-testid="Loadable-loading"
            />
          ) : (
            <Fade in style={{ transitionDelay: isTransitionDelay ? '800ms' : '0ms' }} unmountOnExit>
              <Stack justifyContent="center">
                <CircularProgress data-testid="Loadable-loading" size={size} />
              </Stack>
            </Fade>
          )}
        </Grid>
      </Grid>
    </Box>
  );
});
